import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { NEXT_BUTTON_WIDTH } from 'consts';

import { Position } from './types';

import styles from './NavigationButton.module.scss';

interface Props {
  position: Position;
  handleClickCallback: (value: boolean) => void;
  imageHeight: number;
}

const NavigationButton: React.FC<Props> = ({ position, handleClickCallback, imageHeight }) => {
  const handleClick = () => handleClickCallback(position === Position.Right);
  const intl = useIntl();
  const buttonLabel = intl.formatMessage(
    position === Position.Left ? { defaultMessage: 'Left arrow', id: 'General.Button.ArrowLeft' }
      : { defaultMessage: 'Right arrow', id: 'General.Button.ArrowRight' }
  );

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.left]: position === Position.Left,
        [styles.right]: position === Position.Right,
      })}
      style={{
        height: imageHeight,
      }}
    >
      <button
        aria-label={buttonLabel}
        className={cn(styles.nextButton)}
        onClick={handleClick}
        style={{ width: NEXT_BUTTON_WIDTH }}
        type='button'
      >
        &gt;
      </button>
    </div>
  );
};

export default NavigationButton;
